import { MainPageTemplate } from "src/layout/SidebarLayout/MainPageLayout/MainPageTemplate";
import { LoadingPage } from "src/views/LoadingPage/LoadingPage";

import { CustomersDetailPanel } from "./CustomersDetailPanel";
import { CustomersTable } from "./CustomersTable";
import { CustomersEmptyState } from "./EmptyState";
import { useListAllInstallations } from "./useListAllInstallations";

export const CustomersPage = () => {
  const { data: installations, isLoading } = useListAllInstallations();
  const isEmpty = installations?.length === 0;

  return (
    <MainPageTemplate title="Customers">
      {isLoading ? (
        <LoadingPage variant="table" />
      ) : isEmpty ? (
        <CustomersEmptyState />
      ) : (
        <>
          <CustomersDetailPanel installations={installations || []} />
          <CustomersTable />
        </>
      )}
    </MainPageTemplate>
  );
};
